import { trpc } from "@/lib/trpc";

/**
 * Fire-and-forget hook for owner push notifications.
 * Wraps tRPC notification mutations — errors are silently logged.
 */
export function useOwnerNotify() {
  const bookingFormMutation = trpc.notifications.bookingFormSubmit.useMutation({
    onError: (err) => {
      console.warn("[OwnerNotify] bookingFormSubmit failed:", err.message);
    },
  });

  const bookNowClickMutation = trpc.notifications.bookNowClick.useMutation({
    onError: (err) => {
      console.warn("[OwnerNotify] bookNowClick failed:", err.message);
    },
  });

  /**
   * Notify owner about a booking form submission.
   */
  function notifyBookingForm(data: {
    name: string;
    phone: string;
    service: string;
    notes?: string;
    source: string;
    landingPage?: string;
    acquisitionChannel?: "AI Assistant" | "Organic Search" | "Paid Search" | "Organic Social" | "Referral" | "Direct" | "Other";
    acquisitionSource?: string;
    acquisitionMedium?: string;
    acquisitionCampaign?: string;
    referrerHost?: string;
  }) {
    return bookingFormMutation.mutateAsync(data);
  }

  /**
   * Notify owner about a Book Now / WhatsApp button click.
   */
  function notifyBookNowClick(data: {
    service?: string;
    location: string;
    doctorName?: string;
  }) {
    bookNowClickMutation.mutate(data);
  }

  return { notifyBookingForm, notifyBookNowClick };
}
